var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1445 26.0117L28.1945 49.1917",
    stroke: "#003D6A",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6252 26.2717C54.2652 21.9717 51.9052 17.9117 48.4952 14.5017C37.1752 3.18172 18.8152 3.18172 7.49524 14.5017C4.08524 17.9117 1.72523 21.9717 0.365234 26.2717C0.365234 26.2717 1.65525 22.8117 4.88525 22.8117C8.11525 22.8117 10.0352 26.2717 10.0352 26.2717C10.0352 26.2717 12.5552 22.8117 15.6252 22.8117C18.6952 22.8117 21.3152 26.2717 21.3152 26.2717C21.3152 26.2717 24.7652 22.8117 27.9952 22.8117C31.2252 22.8117 34.6752 26.2717 34.6752 26.2717C34.6752 26.2717 37.4352 22.8117 40.8952 22.8117C44.3552 22.8117 46.6552 26.2717 46.6552 26.2717C46.6552 26.2717 48.8852 22.8117 51.8052 22.8117C54.7252 22.8117 55.6353 26.2717 55.6353 26.2717H55.6252Z",
    fill: "#FFC000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4953 14.5017C42.8853 8.89172 35.5453 6.06172 28.1953 6.01172V22.8217C31.3653 22.9617 34.6753 26.2717 34.6753 26.2717C34.6753 26.2717 37.4353 22.8117 40.8953 22.8117C44.3553 22.8117 46.6553 26.2717 46.6553 26.2717C46.6553 26.2717 48.8853 22.8117 51.8053 22.8117C53.9953 22.8117 55.0453 24.7517 55.4453 25.7317C54.0653 21.6317 51.7753 17.7717 48.5053 14.5117L48.4953 14.5017Z",
    fill: "#0098C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1445 8.05V2",
    stroke: "#003D6A",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2343 46.2787C33.8043 46.7887 35.5843 47.8987 35.5843 49.1787C35.5843 50.9487 32.1843 52.3887 27.9943 52.3887C23.8043 52.3887 20.4043 50.9487 20.4043 49.1787C20.4043 47.8487 22.3143 46.7088 25.0343 46.2188",
    stroke: "#003D6A",
    strokeWidth: 2.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.d597131e624e03efabfa7e39f049dedf.svg";
export { ForwardRef as ReactComponent };